var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvConditions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 67,
    viewBox: "0 0 76 67",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1183.000000, -751.000000) translate(1074.000000, 752.000000) translate(110.000000, 0.000000)",
    stroke: "#000",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.7551761,15.1299456 C56.2150824,15.1314199 53.7167948,15.7719002 51.4936172,16.991575 C50.8506875,10.0885863 46.4164043,4.10394944 39.969765,1.43865089 C33.5231257,-1.22664767 26.1204246,-0.135893634 20.7315637,4.27331155 C15.3427028,8.68251674 12.8506574,15.6877163 14.2552152,22.4784826 C13.3619261,22.2477697 12.4428189,22.1301924 11.5197931,22.1285523 C5.15758698,22.1285524 0,27.2485001 0,33.5642755 C0,39.880051 5.15758698,44.9999986 11.5197931,44.9999988 L58.7551761,44.9999988 C67.0642018,44.9999988 73.799998,38.3133596 73.799998,30.0649722 C73.799998,21.8165848 67.0642018,15.1299456 58.7551761,15.1299456 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1999996,55.7999985 L12.5999997,64.7999983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7999992,55.7999985 L25.1999993,64.7999983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1999989,55.7999985 L39.599999,64.7999983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5999985,55.7999985 L53.9999986,64.7999983"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvConditions);
export default __webpack_public_path__ + "static/media/env-conditions.fd5e5799feefdd5c317538f0ba484dc3.svg";
export { ForwardRef as ReactComponent };